import { loadProjectTableAPI } from "./api";

const initState = {
  pageRoute: {},
  pageList: [],
  workFlowStatus: true,
  loading: false,
  hasPermission: true,
};

let state = {
  ...initState,
};

const getUserContextPrivs = () => {
  const userContext = JSON.parse(window.sessionStorage.getItem("userContext"));
  const { privs } = userContext;
  return privs;
};

const mutations = {};

const actions = {};

// const mutations = {
//   SET_PAGEROUTE: (state, data) => {
//     state.pageRoute = data;
//   },
// };

// const actions = {
//   async getWorkFlowStatus({ commit }, param) {
//     const { id, baseId } = param;
//     const res = await getWorkflowByQualityIdAPI({ qualityId: id });
//     const val = res.data.object.workflowStatus.statusType;
//     let status = true;
//     if (baseId == 401 || baseId == 104) {
//       status = ![3, 4].includes(val);
//     }
//     commit("GET_WORK_FLOW_STATUS", status);
//   },

// };
const getters = {
  getProjectDirectors(state) {
    return state.projectDirectors;
  },
  getPrivsList(state, getters, rootState, rootGetters) {
    const { subClassId } = rootGetters["getObjectId"];
    const list = getUserContextPrivs()
      .filter((i) => i.classId === subClassId)
      .map((i) => i.type);
    return list;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
